import { Brand } from "src/api-service";

// **************************************************************************
// BRAND STATE
// **************************************************************************
export interface BrandState {
    brand: Brand | null;
    brands: Brand[];
    brandsLoading: boolean;
}

export const initialBrandState: BrandState = {
    brand: null,
    brands: [],
    brandsLoading: false,
};
